module.exports = __webpack_public_path__ + "static/media/chanel_rsvp_banner_desktop@2x.4244e4bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/chanel_rsvp_banner_desktop@2x.jpg
// module id = 370
// module chunks = 0